export const TEST_ACTION_TYPE = 'TEST_ACTION_TYPE' as const;
